module.exports = "/fonts/feather.ttf?6a750f0119ba9c8ab8a994a4796599a6";